import { render, staticRenderFns } from "./fapiao.vue?vue&type=template&id=d027dbba&scoped=true&"
import script from "./fapiao.vue?vue&type=script&lang=js&"
export * from "./fapiao.vue?vue&type=script&lang=js&"
import style0 from "./fapiao.vue?vue&type=style&index=0&id=d027dbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d027dbba",
  null
  
)

export default component.exports